import { render, staticRenderFns } from "./TerminalCreateComponent.vue?vue&type=template&id=564fcd7e&"
import script from "./TerminalCreateComponent.vue?vue&type=script&lang=js&"
export * from "./TerminalCreateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports